import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import SideMenu from './SideMenu';
import Breadcrumbs from './Breadcrumbs';
import usePermission from '../hooks/usePermission';
import useAutoTranslate from '../hooks/useAutoTranslate'; // Importación agregada
import {
  FlexBoxJustifyContent, 
  FlexBoxAlignItems, 
  Select, 
  Option, 
  DatePicker, 
  Input, 
  Title, 
  Dialog, 
  ObjectPage,
  ObjectPageSection,
  ObjectPageHeader,
  ObjectPageTitle, 
  ObjectStatus, 
  Label, 
  FlexBox, 
  Button, 
  Form, 
  FormItem, 
  AnalyticalTable,
  Text,
  Icon,
  BusyIndicator,
  Card
} from '@ui5/webcomponents-react';
import axiosInstance from '../utils/axiosInstance';
import FlowDiagram from './flow-diagram';
import AppointmentModal from './appoiment/CreateAppoiment';
import { parseToNumber, formatNumberWithComma, formatedDateTime, rightAlignedNumberStyle, getStatusStyle, getStatusComponentProps, formatCurrency } from '../utils/validator';
import { Cell } from 'recharts';

export const OrderDetail = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [document, setDocument] = useState(null);
  const [open, setOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [activeSection, setActiveSection] = useState('1');
  const navigate = useNavigate();
  const { id } = useParams();
  const [historicDialogOpen, setHistoricDialogOpen] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showStatusDialog, setShowStatusDialog] = useState(false);
  const [newStatus, setNewStatus] = useState('');
  const [rejectionReason, setRejectionReason] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [showAppointmentModal, setShowAppointmentModal] = useState(false);
  const [hasSchedules, setHasSchedules] = useState(false);
  const [scheduleConflicts, setScheduleConflicts] = useState([]);
  const [showScheduleConflictDialog, setShowScheduleConflictDialog] = useState(false);
  const [cancellingSchedules, setCancellingSchedules] = useState(false);
  const { hasPermission } = usePermission();
  const { autoT } = useAutoTranslate(); // Hook de traducción

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleNewASN = () => {
    navigate(`/create-asn/${id}`, {
      state: {
        purchaseOrder: document,
        items: document.items.map(item => ({
          itemPO: item.lineId.toString(),
          materialCode: item.materialCode,
          product: item.description,
          receivedQuantityOC: 0,
          quantityOC: item.quantity,
          unsentASN: 0,
          issuedASN: 0,
          pendingQuantity: item.quantity,
          dispatchQuantity: '',
          status: 'Sent',
          price: item.pricePerUnit,
          deliveryDate: document.deliveryDate,
          center: '',
          warehouse: ''
        }))
      }
    });
  };

  const handleSectionChange = (sectionId) => {
    setActiveSection(sectionId);
  };

  const fetchDocuments = async () => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.get(`purchase-orders/order-number/${id}`);
      if (response.data.code === 'SUCCESS') {
        const doc = response.data.data;
        const docId = doc.id;
        let locked = undefined;
        if (docId) {
          try {
            const detailResp = await axiosInstance.get(`purchase-orders/${docId}`);
            if (detailResp.data && detailResp.data.data) {
              locked = detailResp.data.data.locked;
            }
          } catch (err) {
            console.error(autoT('Error al obtener detalle de la orden:'), err);
          }
        }
        setDocument({ ...doc, locked });
      } else {
        console.error(autoT('Error en la respuesta de la API:'), response.data.message);
      }
    } catch (error) {
      console.error(autoT('Error al obtener los documentos:'), error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, [id]);

  useEffect(() => {
    const location = window.location;
    const urlParams = new URLSearchParams(location.search);
    const errorMessage = urlParams.get('error');
    
    if (errorMessage) {
      setErrorMessage(decodeURIComponent(errorMessage));
      setShowErrorDialog(true);
      urlParams.delete('error');
      const newUrl = `${location.pathname}${urlParams.toString() ? '?' + urlParams.toString() : ''}`;
      window.history.replaceState({}, '', newUrl);
    }
  }, []);

  const fetchPurchaseHistory = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`purchase-orders/history/${id}`);
      if (response.data.code === 'SUCCESS') {
        const groupedAsns = {};

        response.data.data.history.forEach(history => {
          const asnId = history.asnId || history.id;
          if (!groupedAsns[asnId]) {
            groupedAsns[asnId] = {
              id: asnId,
              number: history.asnNumber || autoT('N/A'),
              amount: history.totalPriceLine || '0.000',
              description: `${autoT("Notificación para la orden de compra")} ${response.data.data.orderNumber}`,
              date: new Date(history.asnDate).toLocaleDateString() || autoT('N/A'),
              status: history.asnStatus || autoT('N/A'),
              packages: [],
            };
          }
          groupedAsns[asnId].packages.push({
            number: history.packageNumber || autoT('N/A'),
            weight: history.packageWeight, // Assuming packageWeight exists
            dimensions: history.packageDimensions, // Assuming packageDimensions exists
          });
        });

        const historyData = Object.values(groupedAsns);
        setHistoryData(historyData);
        return historyData;
      }
    } catch (error) {
      console.error(autoT('Error al obtener el historial:'), error);
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchPurchaseHistory();
  }, [id]);

  const handleHistoricoClick = () => {
    setHistoricDialogOpen(true);
  };

  const handleHistoricClose = () => {
    setHistoricDialogOpen(false);
  };

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  const handleSearch = () => {
    console.log(autoT('Searching for:'), searchValue);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const materialColumns = [
    { 
      Header: autoT('Posición OC'), 
      accessor: 'lineId',
      disableResizing: true,
      width: 100
    },
    { 
      Header: autoT('Código de material'), 
      accessor: 'materialCode', 
      disableResizing: true,
      width: 150
    },
    { 
      Header: autoT('Material'), 
      accessor: 'description', 
      disableResizing: true,
      width: 200
    },
    { 
      Header: autoT('Cantidad OC'), 
      accessor: 'quantity',
      Cell: ({ value }) => (
        <Text style={rightAlignedNumberStyle()}>{formatNumberWithComma(value)}</Text>
      ),
      width: 120,
      disableResizing: true
    },
    { 
      Header: autoT('Cantidad recibida'), 
      accessor: 'quantityReceived',
      Cell: ({ value }) => (
        <Text style={rightAlignedNumberStyle()}>{formatNumberWithComma(value) || 0}</Text>
      ),
      width: 145,
      disableResizing: true
    },
    {   
      Header: autoT('Cantidad enviada'), 
      accessor: 'quantitySent',
      Cell: ({ value }) => (
        <Text style={rightAlignedNumberStyle()}>{formatNumberWithComma(value) || 0}</Text>
      ),
      width: 145,
      disableResizing: true
    },
    { 
      Header: autoT('Cantidad pendiente'), 
      accessor: 'quantityPending',
      Cell: ({ value }) => (
        <Text style={rightAlignedNumberStyle()}>{formatNumberWithComma(value) || 0}</Text>
      ),
      width: 160,
      disableResizing: true
    },
    { 
      Header: autoT('Unidad'), 
      accessor: 'unit', 
      width: 80,
      disableResizing: true
    },
    { 
      Header: autoT('Precio unitario'), 
      accessor: 'pricePerUnit',
      Cell: ({ value }) => (
        <Text style={rightAlignedNumberStyle()}>{formatCurrency(value, document?.currency)}</Text>
      ),
      width: 120,
      disableResizing: true
    },
    { 
      Header: autoT('Precio total'), 
      accessor: 'totalPrice',
      Cell: ({ value }) => (
        <Text style={rightAlignedNumberStyle()}>{formatCurrency(value, document?.currency)}</Text>
      ),
      width: 120,
      disableResizing: true
    },
    {
      Header: autoT('Pos. Notif.'), 
      accessor: 'posNotif',
      width: 100,
      disableResizing: true
    }
  ];

  const interlocutorColumns = [
    { 
      Header: autoT('RUT'), 
      accessor: 'clientRut',
      Cell: ({ value }) => (
        <Text>{value || autoT('N/A')}</Text>
      )
    },
    { 
      Header: autoT('Nombre'), 
      accessor: 'clientName',
      Cell: ({ value }) => (
        <Text>{value || autoT('N/A')}</Text>
      )
    },
    { 
      Header: autoT('Dirección'), 
      accessor: 'clientAddress',
      Cell: ({ value }) => (
        <Text>{value || autoT('N/A')}</Text>
      )
    }
  ];

  const MapContent = () => {
    const handleAsnClick = (asnId) => {
      if (!asnId) {
        console.error(autoT("No se encontró ID de ASN"));
        return;
      }
      if (hasPermission('notification', 'listView')) {
        navigate(`/asn/${asnId}`);
      } else {
        console.warn(autoT("No tiene permisos para ver notificaciones"));
      }
    };

    return (
      <FlowDiagram 
        id={id} 
        asns={historyData.map(asn => {
          return {
            ...asn,
            id: asn.id,
            onClick: () => handleAsnClick(asn.id),
            clickable: hasPermission('notification', 'listView')
          };
        })} 
        deliveryDate={document?.deliveryDate}
      />
    );
  };

  const statusOptions = [
    { value: 'All', label: autoT('Todos') },
    { value: 'Open', label: autoT('Despacho Parcial') },
    { value: 'Approved', label: autoT('Despacho Total') },
    { value: 'Shipped', label: autoT('Aceptada') },
    { value: 'Pending', label: autoT('Liberada') },
    { value: 'Canceled', label: autoT('Rechazada') }
  ];

  const getStatusLabel = (statusValue) => {
    const status = statusOptions.find(opt => opt.value === statusValue);
    return status ? status.label : statusValue;
  };

  const handleStatusUpdate = async () => {
    try {
        const token = localStorage.getItem('token');
        const userData = JSON.parse(localStorage.getItem('userData'));

        const requestBody = { 
          status: newStatus, 
          description: rejectionReason,
          modifiedBy: userData.id
        };

        await axiosInstance.put(`/purchase-orders/${document.id}`, requestBody, {
            headers: { 'Authorization': `Bearer ${token}` }
        });

        setShowStatusDialog(false);
        setNewStatus('');
        setRejectionReason('');
        
        await fetchDocuments();
    } catch (error) {
        console.error(autoT('Error al actualizar estado:'), error);
    }
  };

  const calculateTotals = (data) => {
    return data.reduce((totals, item) => {
      totals.quantity += item.quantity || 0;
      totals.quantityReceived += item.quantityReceived || 0;
      totals.quantitySent += item.quantitySent || 0;
      totals.quantityPending += item.quantityPending || 0;
      totals.pricePerUnit += item.pricePerUnit || 0;
      totals.totalPrice += item.totalPrice || 0;
      return totals;
    }, {
      quantity: 0,
      quantityReceived: 0,
      quantitySent: 0,
      quantityPending: 0,
      pricePerUnit: 0,
      totalPrice: 0
    });
  };

  const checkSchedules = async () => {
    try {
      const response = await axiosInstance.get(`purchase-order-schedules/search`, {
        params: {
          orderNumber: id,
          page: 0,
          size: 10,
          sortBy: 'createdAt',
          direction: 'desc'
        }
      });
      
      if (response.data && response.data.data) {
        setHasSchedules(response.data.data.data.length > 0);
      } else {
        setHasSchedules(false);
      }
    } catch (error) {
      console.error(autoT('Error al verificar agendamientos:'), error);
      setHasSchedules(false);
    }
  };

  const checkExistingSchedules = async () => {
    try {
      const response = await axiosInstance.get(`purchase-order-schedules/search`, {
        params: {
          orderNumber: id,
          page: 0,
          size: 10,
          sortBy: 'createdAt',
          direction: 'desc'
        }
      });
      
      if (response.data && response.data.data && response.data.data.data.length > 0) {
        const schedules = response.data.data.data;
        
        if (document?.status === 'Open') {
          setShowAppointmentModal(true);
          return;
        }

        setScheduleConflicts(schedules);
        setShowScheduleConflictDialog(true);
      } else {
        setShowAppointmentModal(true);
      }
    } catch (error) {
      console.error(autoT('Error al verificar agendamientos existentes:'), error);
      // In case of error, still allow creating a new appointment
      setShowAppointmentModal(true);
    }
  };

  const handleCancelSchedulesAndContinue = async () => {
    try {
      setCancellingSchedules(true);
      setErrorMessage('');
      
      // Remove cancellation logic
      setShowScheduleConflictDialog(false);
      setShowAppointmentModal(true);
    } catch (error) {
      console.error(autoT('Error al cancelar agendamientos:'), error);
      setErrorMessage(`${autoT('Hubo un error al cancelar los agendamientos existentes:')} ${error.message || autoT('Error desconocido')}`);
      setShowErrorDialog(true);
    } finally {
      setCancellingSchedules(false);
    }
  };

  useEffect(() => {
    if (id) {
      checkSchedules();
    }
  }, [id]);

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <BusyIndicator active="true" size="L" text={autoT("Buscando orden de compra...")} />
      </div>
    );
  }

  if (!document) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <Text>{autoT("No se encontró la orden")}</Text>
      </div>
    );
  }

  const totals = calculateTotals(document.items || []);

  const tableData = document.items.map(item => ({
    ...item,
    quantity: formatNumberWithComma(Number(item.quantity)),
    quantityReceived: formatNumberWithComma(Number(item.quantityReceived)),
    quantitySent: formatNumberWithComma(Number(item.quantitySent)),
    quantityPending: formatNumberWithComma(Number(item.quantityPending)),
    pricePerUnit: formatNumberWithComma(Number(item.pricePerUnit)),
    totalPrice: formatNumberWithComma(Number(item.totalPrice))
  }));

  const interlocutorData = document ? [
    {
      clientRut: document.clientRut,
      clientName: document.clientName,
      clientAddress: document.clientAddress
    }
  ] : [];

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh' 
    }}>
      <Navbar toggleSidebar={toggleSidebar} />
      <Breadcrumbs />
      <div style={{ 
        display: 'flex',
        flex: 1,
        marginTop: '48px'
      }}>
        <SideMenu isOpen={sidebarOpen} />
        
        <div style={{ 
          flex: 1,
          marginLeft: sidebarOpen ? '250px' : '0',
          transition: 'margin-left 0.3s',
          padding: '20px'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px',
            paddingLeft: '1rem'
          }}>
            <Title level="H2">
              {autoT("ORDEN DE COMPRA N°")} {document?.orderNumber}
            </Title>
            
            <div style={{ 
              display: 'flex', 
              gap: '1rem'
            }}>
              {(document?.status === 'Shipped' || document?.status === 'Open') && (
                <>
                  {hasPermission('schedules', 'create') && (
                    <Button
                      design="Emphasized"
                      icon='calendar'
                      onClick={checkExistingSchedules}
                      style={{
                        opacity: (document?.status === 'Shipped' || document?.status === 'Open') ? 1 : 0.5,
                        marginRight: '1rem'
                      }}
                    >
                      {autoT("Nuevo agendamiento")}
                    </Button>
                  )}
                  
                  {hasSchedules && hasPermission('notification', 'create') && (
                    <Button
                      design="Emphasized"
                      icon='add-equipment'
                      onClick={() => {
                        if (document?.locked) {
                          setErrorMessage(autoT('Otro usuario esta ocupando la orden de compra'));
                          setShowErrorDialog(true);
                        } else {
                          handleNewASN();
                        }
                      }}
                      style={{
                        opacity: (document?.status === 'Shipped' || document?.status === 'Open') ? 1 : 0.5,
                        marginRight: '1rem'
                      }}
                    >
                      {autoT("Nueva Notificación")}
                    </Button>
                  )}
                </>
              )}
              
              {hasPermission('buyorder', 'listView') && (
                <Button 
                  design='Positive' 
                  icon='work-history' 
                  onClick={handleHistoricoClick}
                >
                  {autoT("Histórico")}
                </Button>
              )}
            </div>
          </div>
          <ObjectPage
            headerContentPinnable
            titleArea={
              <ObjectPageTitle>
                <ObjectStatus state={document?.status === 'Approved' ? 'Success' : 'Warning'}>
                  {document?.status}
                </ObjectStatus>
              </ObjectPageTitle>
            }
            headerArea={
              <ObjectPageHeader>
                <FlexBox direction="Column">
                  <Label><strong>{autoT("Fecha de entrega:")}</strong> {document?.deliveryDate}</Label>
                  <Label><strong>{autoT("Monto total:")}</strong> {formatCurrency(document?.totalAmount, document?.currency)}</Label>
                </FlexBox>
              </ObjectPageHeader>
            }
            style={{
              height: 'calc(100vh - 170px)',
              minHeight: '420px'
            }}
          >
            <ObjectPageSection id="general-information" titleText={autoT("Información General")}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <div style={{ 
                  backgroundColor: 'white',
                  padding: '1rem',
                  borderRadius: '8px',
                  boxShadow: '0 0 4px rgba(0,0,0,0.1)'
                }}>
                  <Title level="H5" style={{ marginBottom: '1rem' }}>{autoT("Datos Básicos")}</Title>
                  
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <div>
                      <Label style={{ display: 'block', marginBottom: '0.5rem' }}>{autoT("N° Orden:")}</Label>
                      <Text>{document?.orderNumber}</Text>
                    </div>
                    <div>
                      <Label style={{ display: 'block', marginBottom: '0.5rem' }}>{autoT("Proveedor:")}</Label>
                      <Text>{document?.supplier.supplierName}</Text>
                    </div>
                    <div>
                      <Label style={{ display: 'block', marginBottom: '0.5rem' }}>{autoT("Moneda:")}</Label>
                      <Text>{document?.currency || autoT('N/A')}</Text>
                    </div>
                  </div>
                </div>

                <div style={{ 
                  backgroundColor: 'white',
                  padding: '1rem',
                  borderRadius: '8px',
                  boxShadow: '0 0 4px rgba(0,0,0,0.1)'
                }}>
                  <Title level="H5" style={{ marginBottom: '1rem' }}>{autoT("Condición de pago")}</Title>
                  
                  <div>
                    <Label style={{ display: 'block', marginBottom: '0.5rem' }}>{autoT("Término de pago en días:")}</Label>
                    <Text>{document?.supplier.paymentTermDays || autoT('N/A')}</Text>
                  </div>
                </div>

                <div style={{ 
                  backgroundColor: 'white',
                  padding: '1rem',
                  borderRadius: '8px',
                  boxShadow: '0 0 4px rgba(0,0,0,0.1)'
                }}>
                  <Title level="H5" style={{ marginBottom: '1rem' }}>{autoT("Condición de entrega")}</Title>
                  
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <div>
                      <Label style={{ display: 'block', marginBottom: '0.5rem' }}>{autoT("Incoterms:")}</Label>
                      <Text>{document?.incoterm || autoT('N/A')}</Text>
                    </div>
                    <div>
                      <Label style={{ display: 'block', marginBottom: '0.5rem' }}>{autoT("Ubicación de entrega:")}</Label>
                      <Text>{document?.supplier.deliveryConditions + ' - ' + document?.clientAddress || autoT('N/A')}</Text>
                    </div>
                    <div>
                      <Label style={{ display: 'block', marginBottom: '0.5rem' }}>{autoT("Fecha de entrega:")}</Label>
                      <Text>{document?.deliveryDate}</Text>
                    </div>
                    {document?.scheduleNumber && (
                      <div>
                        <Label style={{ display: 'block', marginBottom: '0.5rem' }}>{autoT("Último agendamiento")}</Label>
                        <Text>{document?.scheduleNumber}</Text>
                        <Label style={{ display: 'block', marginBottom: '0.5rem', marginTop: '0.5rem' }}>{autoT("Datos agendamiento")}</Label>
                        <Text>
                          <Label style={{ display: 'inline', fontWeight: 'bold', marginRight: '4px' }}>{autoT("Fecha:")}</Label> 
                          {formatedDateTime(document?.scheduleDate)} {' '}
                          <Label style={{ display: 'inline', fontWeight: 'bold', marginRight: '4px' }}>{autoT("Contacto:")}</Label> 
                          {document?.scheduleContact} - {document?.scheduleMailContact}
                        </Text>
                      </div>
                    )}
                  </div>
                </div>

                <div style={{ 
                  backgroundColor: 'white',
                  padding: '1rem',
                  borderRadius: '8px',
                  boxShadow: '0 0 4px rgba(0,0,0,0.1)'
                }}>
                  <Title level="H5" style={{ marginBottom: '1rem' }}>{autoT("Estado de la Orden")}</Title>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '2rem' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Label style={{ display: 'block', marginBottom: '0.5rem' }}>{autoT("Estado:")}</Label>
                      <Button 
                        onClick={() => document?.status === 'Pending' && hasPermission('buyorder', 'update') ? setShowStatusDialog(true) : null}
                        disabled={document?.status !== 'Pending' || !hasPermission('buyorder', 'update')}
                        style={{
                          ...getStatusComponentProps(document?.status, null, {
                            cursor: (document?.status === 'Pending' && hasPermission('buyorder', 'update')) ? 'pointer' : 'default',
                            opacity: (document?.status === 'Pending' && hasPermission('buyorder', 'update')) ? 1 : 0.7
                          }).style
                        }}
                      >
                        {getStatusLabel(document?.status)}
                      </Button>
                    </div>

                    <div style={{
                      marginLeft: '0px',
                      ...getStatusStyle(document?.status),
                      borderRadius: '4px',
                      padding: '5px',
                      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    }}>
                      
                      <div style={{ display: 'flex', gap: '2rem' }}>
                        <div style={{ flex: 1 }}>
                          <Label style={{ fontWeight: 'bold', fontSize: '0.9rem' }}>
                            {autoT("Motivo:")}
                          </Label>
                          <Text style={{ 
                            display: 'block', 
                            marginTop: '0.25rem',
                            color: getStatusStyle(document?.status).color,
                            fontSize: '0.9rem'
                          }}>
                            {document?.description || autoT('No se especificó motivo')}
                          </Text>
                        </div>
                        
                        <div>
                          <Label style={{ fontWeight: 'bold', fontSize: '0.9rem' }}>
                            {autoT("Evaluado por:")}
                          </Label>
                          <Text style={{ 
                            display: 'block', 
                            marginTop: '0.25rem',
                            color: getStatusStyle(document?.status).color,
                            fontSize: '0.9rem'
                          }}>
                            {document?.modifiedByName || autoT('Usuario no especificado')}
                          </Text>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ObjectPageSection>
            <ObjectPageSection id="service-lines" titleText={autoT("Materiales")}>
              <div style={{ 
                backgroundColor: 'white',
                padding: '1rem',
                borderRadius: '8px',
                boxShadow: '0 0 4px rgba(0,0,0,0.1)',
                position: 'relative'
              }}>
                {document.items && document.items.length > 0 ? (
                  <>
                    <div style={{ marginBottom: '-2px' }}>
                      <AnalyticalTable
                        data={tableData}
                        columns={materialColumns}
                        visibleRows={5}
                        minRows={5}
                        scaleWidthMode="Fixed"
                        columnConfig={{
                          resizable: false
                        }}
                        selectionMode="None"
                        style={{ 
                          "--sapList_BorderColor": "#e5e5e5"
                        }}
                      />
                    </div>
                    
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      minHeight: '44px',
                      borderTop: '2px solid #e5e5e5',
                      backgroundColor: 'white',
                      fontWeight: 'bold',
                      width: 'fit-content',
                      minWidth: '100%'
                    }}>
                      {materialColumns.map((col) => {
                        const width = col.width || 100;
                        const isMoneyColumn = col.accessor === 'pricePerUnit' || col.accessor === 'totalPrice';
                        const isQuantityColumn = col.accessor === 'quantity' || col.accessor === 'quantityReceived' || col.accessor === 'quantitySent' || col.accessor === 'quantityPending';
                        let content = '';
                        if (col.accessor === 'lineId') {
                          content = autoT('Totales:');
                        } else if (isMoneyColumn) {
                          const numericValue = (typeof totals[col.accessor] === 'number' || !isNaN(parseFloat(totals[col.accessor]))) ? totals[col.accessor] : 0;
                          content = formatCurrency(numericValue, document?.currency);
                        } else if (isQuantityColumn) {
                          const numericValue = (typeof totals[col.accessor] === 'number' || !isNaN(parseFloat(totals[col.accessor]))) ? totals[col.accessor] : 0;
                          content = formatNumberWithComma(numericValue);
                        }
                        return (
                          <div
                            key={col.accessor}
                            style={{
                              width: `${width}px`,
                              flex: '0 0 auto',
                              padding: '0 0.5rem',
                              boxSizing: 'border-box',
                              textAlign: (isMoneyColumn || isQuantityColumn) ? 'right' : 'left',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis'
                            }}
                          >
                            {content}
                          </div>
                        );
                      })}
                    </div>
                  </>
                ) : (
                  <Text>{autoT("No hay materiales disponibles")}</Text>
                )}
              </div>
            </ObjectPageSection>
            <ObjectPageSection id="interlocutors" titleText={autoT("Interlocutores")}>
              <div style={{ 
                backgroundColor: 'white',
                padding: '1rem',
                borderRadius: '8px',
                boxShadow: '0 0 4px rgba(0,0,0,0.1)'
              }}>
                <AnalyticalTable
                  data={interlocutorData}
                  columns={interlocutorColumns}
                  visibleRows={5}
                  minRows={5}
                  scaleWidthMode="Smart"
                />
              </div>
            </ObjectPageSection>
          </ObjectPage>

          <Dialog
            open={historicDialogOpen}
            onAfterClose={handleHistoricClose}
            style={{ width: '1000px', maxHeight: '900px' }}
          >
            <div style={{ padding: '20px' }}>
              <Title level="H4" style={{ textAlign: 'center', marginBottom: '20px' }}>
                {autoT("Histórico de la orden de compra")}
              </Title>
              <Title level="H4" style={{ textAlign: 'center', marginBottom: '20px' }}>
                N° {document?.orderNumber}
              </Title>

              <MapContent />

            </div>
            
            <FlexBox 
              justifyContent={FlexBoxJustifyContent.End}
              style={{ 
                padding: '15px',
                borderTop: '1px solid #ddd',
                backgroundColor: '#f5f5f5'
              }}
            >
              <Button onClick={handleHistoricClose}>{autoT("Cerrar")}</Button>
            </FlexBox>
          </Dialog>

          {showStatusDialog && (
            <Dialog
              open={showStatusDialog}
              headerText={autoT("Cambiar Estado de la Orden")}
              onAfterClose={() => {
                setShowStatusDialog(false);
                setRejectionReason('');
              }}
            ><div style={{ padding: '1rem' }}>
            <Select
              value={newStatus}
              onChange={(event) => setNewStatus(event.detail.selectedOption.value)}
              style={{ width: '100%', marginBottom: '1rem' }}
            >
              <Option value="" disabled>-- {autoT("Escoja Nuevo Estado")} --</Option>
              <Option value="Shipped">{autoT("Aceptada")}</Option>
              <Option value="Canceled">{autoT("Rechazada")}</Option>
            </Select>
          
            <textarea
              placeholder={autoT("Ingrese el motivo del cambio de estado")}
              value={rejectionReason}
              onChange={(e) => setRejectionReason(e.target.value)}
              style={{ width: '100%', marginBottom: '1rem', height: '100px' }}
            />
          
            <FlexBox justifyContent={FlexBoxJustifyContent.End} style={{ gap: '0.5rem' }}>
              <Button 
                design="Transparent" 
                onClick={() => setShowStatusDialog(false)}
              >
                {autoT("Cancelar")}
              </Button>
              <Button 
                onClick={() => {
                  if (!rejectionReason.trim()) {
                    setErrorMessage(autoT('El motivo no puede estar vacío.'));
                    setShowErrorDialog(true);
                    return;
                  }
                  handleStatusUpdate();
                }}
                style={{
                  backgroundColor: '#343a40',
                  color: '#fff'
                }}
              >
                {autoT("Confirmar")}
              </Button>
            </FlexBox>
          </div>
          </Dialog>
          )}
          
          {/* Diálogo de error */}
          {showErrorDialog && (
          <Dialog
            open={showErrorDialog}
            headerText={autoT("Error")}
            onAfterClose={() => setShowErrorDialog(false)}
          >
            <div style={{ padding: '1rem' }}>
              <Text>{errorMessage}</Text>
              
              <FlexBox justifyContent={FlexBoxJustifyContent.End} style={{ marginTop: '1rem' }}>
                <Button 
                  design="Emphasized"
                  onClick={() => setShowErrorDialog(false)}
                >
                  {autoT("Entendido")}
                </Button>
              </FlexBox>
            </div>
          </Dialog>
          )}
          
          {/* Diálogo de conflicto de agendamientos */}
          <Dialog
            open={showScheduleConflictDialog}
            headerText={autoT("Agendamientos Existentes")}
            onAfterClose={() => setShowScheduleConflictDialog(false)}
            style={{ width: '600px' }}
          >
            <div style={{ padding: '1rem' }}>
              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '1rem', 
                marginBottom: '1rem',
                backgroundColor: '#fff3cd',
                padding: '1rem',
                borderRadius: '4px',
                border: '1px solid #ffeeba'
              }}>
                <Icon name="alert" style={{ color: '#856404', fontSize: '1.5rem' }} />
                <div>
                  <Title level="H5" style={{ color: '#856404', marginBottom: '0.5rem' }}>
                    {autoT("Atención")}
                  </Title>
                  <Text style={{ color: '#856404' }}>
                    {autoT("Esta orden ya tiene agendamientos activos. Si continúa, deberá cancelar los agendamientos existentes o el proveedor deberá cumplir con múltiples agendamientos.")}
                  </Text>
                </div>
              </div>
          
              <Title level="H5" style={{ marginBottom: '1rem' }}>{autoT("Agendamientos existentes:")}</Title>
              
              <div style={{ 
                maxHeight: '200px', 
                overflowY: 'auto',
                border: '1px solid #ddd',
                borderRadius: '4px',
                marginBottom: '1rem'
              }}>
                {scheduleConflicts.map((schedule, index) => (
                  <div key={index} style={{ 
                    padding: '0.75rem', 
                    borderBottom: index < scheduleConflicts.length - 1 ? '1px solid #eee' : 'none',
                    backgroundColor: index % 2 ? '#f9f9f9' : 'white'
                  }}>
                    <div><strong>{autoT("ID:")}</strong> {schedule.appoimentNumber}</div>
                    <div><strong>{autoT("Fecha:")}</strong> {new Date(schedule.scheduleDate).toLocaleString('es-ES')}</div>
                    <div><strong>{autoT("Tipo:")}</strong> {schedule.isDelivery === 'DELIVERY' ? autoT("Despacho") : autoT("Retiro")}</div>
                    <div><strong>{autoT("Estado:")}</strong> {schedule.status === 'PENDING' ? autoT("Pendiente") : 
                                                     schedule.status === 'COMPLETED' ? autoT("Completado") : 
                                                     schedule.status === 'CANCELLED' ? autoT("Cancelado") : 
                                                     schedule.status}</div>
                  </div>
                ))}
              </div>
          
              <FlexBox justifyContent={FlexBoxJustifyContent.End} style={{ gap: '0.5rem' }}>
                <Button 
                  design="Transparent" 
                  onClick={() => setShowScheduleConflictDialog(false)}
                  disabled={cancellingSchedules}
                >
                  {autoT("Cancelar")}
                </Button>
                <Button 
                  onClick={handleCancelSchedulesAndContinue}
                  disabled={cancellingSchedules}
                  style={{
                    backgroundColor: '#343a40',
                    color: '#fff'
                  }}
                >
                  {cancellingSchedules ? (
                    <>
                      <BusyIndicator active size="Small" style={{ marginRight: '8px' }} />
                      {autoT("Cancelando agendamientos...")}
                    </>
                  ) : autoT('Continuar de todas formas')}
                </Button>
              </FlexBox>
            </div>
          </Dialog>
          
          {/* Agregar el modal de agendamiento */}
          <AppointmentModal
            isOpen={showAppointmentModal}
            onClose={() => setShowAppointmentModal(false)}
            orderNumber={document?.orderNumber}
            purchaseOrderId={document?.id}
            deliveryDate={document?.deliveryDate}
            warehouseId={document?.warehouseId}
            deliveryAddress={document?.clientAddress}
          />
        </div>
      </div>
    </div>
  );
};

export default OrderDetail;